import { render } from "./ClaimHome.vue?vue&type=template&id=6b6a6a1b&scoped=true"
import script from "./ClaimHome.vue?vue&type=script&lang=js"
export * from "./ClaimHome.vue?vue&type=script&lang=js"

import "./ClaimHome.vue?vue&type=style&index=0&id=6b6a6a1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6a6a1b"]])

export default __exports__